/**
 * איסוף כתובת תשלום חיצונית ופתיחה עם fallback כשחוסמים popup.
 * הערה: היום רוב זרימת CVAC משתמשת במודאל LDS/Tranzila בלי URL מהשרת —
 * ראו INTENT_CREATE_PAYMENT_LINK ב־customer_chat_service (payment.available ללא payment_url).
 */

const PAYMENT_URL_KEYS = [
  "payment_url",
  "iframe_url",
  "redirect_url",
  "checkout_url",
  "url",
  "link",
];

function isHttpUrlString(v) {
  if (typeof v !== "string") return false;
  const t = v.trim();
  return t.startsWith("https://") || t.startsWith("http://");
}

function pickUrlFromObject(obj) {
  if (!obj || typeof obj !== "object") return null;
  for (const k of PAYMENT_URL_KEYS) {
    const v = obj[k];
    if (isHttpUrlString(v)) return v.trim();
  }
  return null;
}

/**
 * @param {{ payment?: unknown, client_actions?: unknown }} source
 * @returns {string|null}
 */
export function extractCustomerChatPaymentUrl(source) {
  const pay = source?.payment;
  const u0 = pickUrlFromObject(pay);
  if (u0) return u0;
  const actions = source?.client_actions;
  if (!Array.isArray(actions)) return null;
  for (const a of actions) {
    const u = pickUrlFromObject(a);
    if (u) return u;
  }
  return null;
}

/**
 * @param {unknown} payment
 * @param {unknown} client_actions
 */
export function customerChatPaymentIntentVisible(payment, client_actions) {
  if (payment && typeof payment === "object" && payment.available === true) return true;
  if (!Array.isArray(client_actions)) return false;
  return client_actions.some((a) => a?.type === "open_vacation_package_payment");
}

/**
 * @param {unknown} client_actions
 * @returns {string|null}
 */
export function extractVacationPaymentAgentId(client_actions) {
  if (!Array.isArray(client_actions)) return null;
  const a = client_actions.find((x) => x?.type === "open_vacation_package_payment");
  const raw = a?.agent_id;
  if (raw == null || String(raw).trim() === "") return null;
  return String(raw).trim();
}

/**
 * אפשר לפתוח מודאל תשלום (אותה לוגיקה כמו client_action) גם כשאין URL חיצוני.
 * @param {unknown} payment
 * @param {unknown} client_actions
 */
export function customerChatCanOpenPaymentModal(payment, client_actions) {
  if (Array.isArray(client_actions)) {
    const has = client_actions.some((a) => a?.type === "open_vacation_package_payment");
    if (has) return true;
  }
  if (!payment || typeof payment !== "object") return false;
  if (payment.available !== true) return false;
  if (payment.reason === "client_open_payment_modal") return true;
  if (payment.target === "lds_tranzila_iframe") return true;
  return false;
}

/**
 * @param {string} url
 * @param {{ variant?: 'manual' | 'auto' }} [opts]
 * @returns {{ ok: boolean, blocked: boolean, showDirectLink: boolean }}
 */
export function openCustomerChatPaymentUrl(url, opts = {}) {
  const variant = opts.variant === "auto" ? "auto" : "manual";
  if (!isHttpUrlString(url)) {
    // eslint-disable-next-line no-console
    console.warn("PAYMENT_URL_MISSING", { variant, reason: "invalid_or_empty_url" });
    return { ok: false, blocked: false, showDirectLink: false };
  }
  const u = url.trim();
  if (variant === "manual") {
    // eslint-disable-next-line no-console
    console.info("PAYMENT_MANUAL_OPEN_CLICKED", { variant: "url", urlLength: u.length });
  }
  // eslint-disable-next-line no-console
  console.info("PAYMENT_AUTO_OPEN_ATTEMPT", { variant, mode: "window_open", urlLength: u.length });
  const w = window.open(u, "_blank", "noopener,noreferrer");
  const opened = w != null && typeof w === "object" && !w.closed;
  if (opened) {
    // eslint-disable-next-line no-console
    console.info("PAYMENT_AUTO_OPEN_SUCCESS", { variant, mode: "window_open" });
    return { ok: true, blocked: false, showDirectLink: false };
  }
  // eslint-disable-next-line no-console
  console.warn("PAYMENT_AUTO_OPEN_BLOCKED", { variant, mode: "window_open" });
  return { ok: false, blocked: true, showDirectLink: true };
}
